import React, { useState } from 'react';
import { get } from 'lodash/fp';
import PropTypes from 'prop-types';

import LanguageConverter from '@careerstart/wae-common/src/main/helperFunction/LanguageConverter';
import { Grid } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';

const FormSwitch = ({ disabled, input, label, labelKey, xs, testId, labelPlacement }) => {
  const [val, setVal] = useState(get('value', input) !== undefined ? get('value', input) : true);
  const handleOnChange = () => {
    setVal(!val);
    input.onChange(!val);
  };
  const IOSSwitch = styled((props, onChange) => (
    <Switch
      value={val}
      onChange={onChange}
      checked={val}
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      data-testid={testId}
      {...props}
    />
  ))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
      padding: 0,
      margin: 2,
      transitionDuration: '300ms',
      '&.Mui-checked': {
        transform: 'translateX(16px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#65C466',
          opacity: 1,
          border: 0,
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 0.5,
        },
      },
      '&.Mui-focusVisible .MuiSwitch-thumb': {
        color: '#33cf4d',
        border: '6px solid #fff',
      },
      '&.Mui-disabled .MuiSwitch-thumb': {
        color: theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600],
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
      },
    },
    '& .MuiSwitch-thumb': {
      boxSizing: 'border-box',
      width: 22,
      height: 22,
    },
    '& .MuiSwitch-track': {
      borderRadius: 26 / 2,
      backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
      opacity: 1,
      transition: theme.transitions.create(['background-color'], {
        duration: 500,
      }),
    },
  }));
  return (
    <Grid item xs={xs}>
      <FormControlLabel
        control={<IOSSwitch value={val} disabled={disabled} onChange={() => handleOnChange()} />}
        label={labelKey ? LanguageConverter(labelKey) : label}
        labelPlacement={labelPlacement}
        sx={{ width: '100%', justifyContent: 'space-between' }}
      />
    </Grid>
  );
};
FormSwitch.propTypes = {
  disabled: PropTypes.bool,
  input: PropTypes.shape({
    onChange: PropTypes.func,
    values: PropTypes.bool,
    value: PropTypes.bool,
  }),
  label: PropTypes.string,
  labelKey: PropTypes.string,
  testId: PropTypes.string,
  labelPlacement: PropTypes.string,
  xs: PropTypes.number,
};

export default FormSwitch;
